import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import { Text, Box, Link as CoreLink, slugify } from "@miro-site/core";
import styled from "styled-components";
var Title = styled(CoreLink).attrs(function(props) {
    return {
        $mb: props.theme.header.secondaryNavigation.item.margins.afterTitle,
        $styles: _object_spread({}, props.theme.header.secondaryNavigation.item.title.styles)
    };
}).withConfig({
    componentId: "sc-d0406934-0"
})(_templateObject());
var Description = styled(Text).attrs(function(props) {
    return {
        as: "p",
        $styles: _object_spread({}, props.theme.header.secondaryNavigation.item.description.styles)
    };
}).withConfig({
    componentId: "sc-d0406934-1"
})(_templateObject1());
var Wrapper = styled(Box).attrs(function(param) {
    var $isFocused = param.$isFocused, _theme = param.theme, focus = _theme.focus, _header = _theme.header, item = _header.secondaryNavigation.item;
    var visibleAnimation = {
        opacity: 1,
        transform: "scale(1)",
        transition: item.hover.animation.show
    };
    var _obj;
    var hoverStyles = (_obj = {}, _define_property(_obj, Title, item.title.hoverStyles), _define_property(_obj, Description, item.description.hoverStyles), _obj);
    return {
        $styles: _object_spread({
            display: "block",
            position: "relative",
            marginTop: item.margins.before,
            marginBottom: item.margins.after,
            maxWidth: item.maxWidth,
            cursor: "pointer",
            ":before": _object_spread({
                position: "absolute",
                content: "''",
                transform: "scale(.9)",
                zIndex: -1,
                opacity: 0,
                transition: item.hover.animation.hide,
                width: "calc(100% + ".concat(item.hover.offset.left + item.hover.offset.right, "px)"),
                height: "calc(100% + ".concat(item.hover.offset.top + item.hover.offset.bottom, "px)"),
                top: "-".concat(item.hover.offset.top, "px"),
                left: "-".concat(item.hover.offset.left, "px"),
                borderRadius: item.hover.radius,
                background: item.hover.background,
                border: "1px solid transparent"
            }, $isFocused ? _object_spread({}, focus.outlines.default, visibleAnimation) : {}),
            ":hover": _object_spread({
                ":before": _object_spread({}, visibleAnimation)
            }, hoverStyles)
        }, $isFocused ? hoverStyles : {})
    };
}).withConfig({
    componentId: "sc-d0406934-2"
})(_templateObject2());
var SecondaryNavigationItem = function(props) {
    var title = props.title, description = props.description, path = props.path, className = props.className;
    var linkRef = useRef(null);
    var descriptionId = "".concat(slugify(title), "-description");
    var ref = useState(false), isFocused = ref[0], setFocused = ref[1];
    var handleClick = function(e) {
        var ref;
        if (!((ref = linkRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            var ref1;
            (ref1 = linkRef.current) === null || ref1 === void 0 ? void 0 : ref1.click();
        }
    };
    return /*#__PURE__*/ _jsxs(Wrapper, {
        $isFocused: isFocused,
        className: className,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ _jsx(Title, {
                ref: linkRef,
                onFocus: function(e) {
                    if (e.target === linkRef.current) {
                        setFocused(true);
                    }
                },
                onBlur: function() {
                    return setFocused(false);
                },
                href: path,
                "aria-describedby": descriptionId,
                children: title
            }),
            /*#__PURE__*/ _jsx(Description, {
                id: descriptionId,
                children: description
            })
        ]
    });
};
export default SecondaryNavigationItem;
